<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>商品管理</el-breadcrumb-item>
			<el-breadcrumb-item>热门商品</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="btns">
			<el-button type="danger" size="small" @click="delAll">批量取消</el-button>
		</div>
		<!--		数据是list 通过list展示-->
		<el-table :data="list" border @selection-change="handleSelectionChange">
			<el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column label="主图">
				<template slot-scope="scope">
					<div style="display: flex; align-items: center;">
						<img :src="scope.row.product_pic_main" height="30" />
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="category" label="商品分类">
				<template slot-scope="scope" v-if="scope.row.category">
					{{scope.row.category.name}}
				</template>
			</el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_marketable">
						已上架
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						已下架
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="160">
				<template slot-scope="scope">
					<el-button size="mini" type="primary" @click="edit(scope.row.goods_id)">查看</el-button>
					<el-popconfirm title="您确定要取消这条数据吗？" @confirm="del(scope.row.goods_id)" class="l10">
						<el-button size="mini" type="danger" slot="reference">取消</el-button>
					</el-popconfirm>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
			:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				list: [],
				isLoad: false,
				pageSize: 20,
				total: 0,
				page: 1,
				multipleSelection: []
			}
		},
		created() {
			this.loadList()
		},
		methods: {
			loadList() {
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.get('/store/product/listFind', {
						params: {
							page: this.page,
							limit: this.pageSize
						}
					})
					.then(res => {
						this.isLoad = false
						// 获取数据
						this.list = res.data.list.data
						// 页数 page
						this.total = res.data.list.total
					})
					.catch(() => {
						this.isLoad = false
					})
			},
			// 传一个ID跳转到edit页面，进行编辑
			edit(id) {
				this.$router.push({
					path: '/Goods/edit.html',
					query: {
						id: id
					}
				});
			},
			//
			del(id) {
				let ids = [id]
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.axios.post('/store/product/delToFind', {
						ids: ids
					})
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '取消成功',
							showClose: false
						});
						this.loadList()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			delAll() {
				let id = []
				for (let key in this.multipleSelection) {
					let item = this.multipleSelection[key]
					id.push(item.goods_id)
				}
				if (id.length == 0) {
					return false;
				}
				if (this.isLoad)
					return
				this.isLoad = !this.isLoad
				this.axios.post('/store/product/delToFind', {
					ids: id
				}).then(() => {
					this.isLoad = !this.isLoad
					this.$message.success({
						message: '取消成功',
						showClose: false
					});
					this.loadList()
				})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},

			sizeReload(val) {
				this.pageSize = val
				this.loadList()
			},
			pageReload(val) {
				this.page = val
				this.loadList()
			}
		}
	}
</script>
<style scoped>
</style>
